import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-effective-date-adoption-date",
  // imports: [],
  templateUrl: "./effective-date-adoption-date.component.html",
  styleUrl: "./effective-date-adoption-date.component.css",
  standalone: false,
})
export class EffectiveDateAdoptionDateComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
